import { Radio } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  PF,
  HAS_RECORDS_RADIO_OPTIONS,
} from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui/FilterWrapper';

export const HasRecordsFilter: ContentType = ({ open, onClose, id }) => {
  const [localHasRecords, setLocalHasRecords] = useState<boolean | null>(null);
  const { filtersMap, onChangeHasRecords } = useNewClientsListContext();

  const { hasRecords } = filtersMap.get(id)!;
  const onConfirm = useCallback(() => {
    if (localHasRecords === null) {
      onClose?.();
      return;
    }
    onChangeHasRecords(localHasRecords, id);
    onClose?.();
  }, [localHasRecords, onChangeHasRecords, onClose, id]);

  useEffect(() => {
    if (open) {
      setLocalHasRecords(hasRecords);
    } else {
      setLocalHasRecords(null);
    }
  }, [hasRecords, open]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Radio.Group
        value={localHasRecords}
        onChange={({ target: { value } }) => setLocalHasRecords(value)}
        options={HAS_RECORDS_RADIO_OPTIONS}
        className={`${PF}__radio-group`}
      />
    </FilterWrapper>
  );
};
